import { useEffect, useState } from 'react'
import theme from '../styles/theme'

const useDetectDevices = () => {
  const [devices, setDevices] = useState({ mobile: true, desktop: true })
  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${theme.breakpoints.desktopSmall}px)`)
    setDevices({ mobile: !mq.matches, desktop: mq.matches })
  }, [])
  return { devices }
}

export default useDetectDevices
